import React, { useEffect, useState } from 'react'
import { StyledRegistrationFinish } from './styled'
import SimpleMemberLayout from 'spa/member/layouts/SimpleMemberLayout/Index'
import { useLoggedIn } from 'spa/member/hooks/useLoggedIn'
import { useLocation } from 'react-router-dom'
import { StyledRegistrationFinishWithJobOffer } from './WithJobOffer/styled'
import { JobOfferSummary } from 'javascripts/api/generated'
import { API } from 'javascripts/api'

const Index: React.FC = () => {
  const loggedIn = useLoggedIn()
  const location = useLocation()
  const [jobOfferSummary, setJobOfferSummary] = useState<JobOfferSummary | null>(null)
  const jobOfferId = new URLSearchParams(location.search).get('job_offer_id')

  const fetchJobOfferSummary = async (jobOfferId: string) => {
    const response = await API.getUserJobOfferSummary(Number(jobOfferId))

    setJobOfferSummary(response.data)
  }

  useEffect(() => {
    if (!jobOfferId) {
      setJobOfferSummary(null)
      return
    }

    fetchJobOfferSummary(jobOfferId)
  }, [jobOfferId])

  if (!loggedIn) {
    return null
  }

  let styledTemplate

  if (jobOfferId) {
    styledTemplate = <StyledRegistrationFinishWithJobOffer jobOfferSummary={jobOfferSummary} />
  } else {
    styledTemplate = <StyledRegistrationFinish />
  }

  return (
    <SimpleMemberLayout stickyFooter>
      {styledTemplate}
    </SimpleMemberLayout>
  )
}

export default Index
